// Froala Editor JS files.
import 'froala-editor/js/froala_editor.pkgd.min.js'
import 'froala-editor/js/plugins.pkgd.min.js'
import 'froala-editor/js/languages/it.js'
// Froala Editor CSS files.
import 'froala-editor/css/froala_style.min.css'
import 'froala-editor/css/froala_editor.pkgd.min.css'
import 'froala-editor/css/plugins.pkgd.min.css'

import React, { FC } from 'react'
import FroalaEditor from 'react-froala-wysiwyg'

import { useAppSelector } from '../../redux/hooks'
import { FroalaWrapper } from './article.components'

interface Props {
  value: string
  setValue: (data: string) => void
}

const FroalaBody: FC<Props> = (props: Props) => {
  const language = useAppSelector((state) => state.locale.value)
  const handleBodyFroala = (model: string) => {
    props.setValue(model)
  }

  return (
    <FroalaWrapper>
      <FroalaEditor
        tag='textarea'
        config={{
          width: 656,
          attribution: false,
          fontSize: ['8', '9', '10', '11', '12', '14', '16', '18', '20', '24', '30', '36', '48', '60', '72'],
          fontFamily: {
              "'Open Sans',sans-serif": 'Open Sans',
              'Arial,Helvetica,sans-serif': 'Arial',
              'Georgia,serif': 'Georgia', 'Impact,Charcoal,sans-serif': 'Impact',
              'Times New Roman,Times,serif': 'Times New Roman',
              'Verdana,Geneva,sans-serif': 'Verdana'
          },
          fontFamilyDefaultSelection: 'Open Sans',
          fontSizeDefaultSelection: '16',
          fontSizeSelection: true,
          fontFamilySelection: true,
          toolbarInline: false,
          toolbarSticky: true,
          tableResizerOffset: 10,
          tableResizingLimit: 10,
          lineBreakerTags: ['noExistsTags'],
          toolbarContainer: '#stickyToolbar',
          imageUploadParam: 'image_param',
          imageUploadURL: process.env.REACT_APP_HOST_API + '/help/upload',
          requestWithCredentials: true,
          imageUploadMethod: 'POST',
          imageMaxSize: 5 * 1024 * 1024,
          imageAllowedTypes: ['jpeg', 'jpg', 'png', 'gif'],
          imageEditButtons: [
            'imageReplace',
            'imageAlign',
            'imageRemove',
            'imageLink',
            'linkOpen',
            'linkEdit',
            'linkRemove',
            'imageDisplay',
            'imageAlt',
            'imageSize',
          ],
          imageDefaultWidth: 0,
          key: 'kRB4zA4D1C1G3C2H1qYFa1UQRFQIVc2MSMd1IWPNb1IFd1yD2I2D1B3C7D2B1C5G1B1',
          language: language ?? 'it',
          toolbarButtons: {
            moreText: {
              buttons: [
                'bold',
                'italic',
                'underline',
                'strikeThrough',
                'subscript',
                'superscript',
                'fontFamily',
                'fontSize',
                'textColor',
                'backgroundColor',
                'inlineClass',
                'inlineStyle',
                'clearFormatting',
              ],
              align: 'left',
              buttonsVisible: 3,
            },
            moreParagraph: {
              buttons: [
                'alignJustify',
                'alignLeft',
                'alignCenter',
                'alignRight',
                'formatOL',
                'formatUL',
                'paragraphFormat',
                'paragraphStyle',
                'lineHeight',
                'outdent',
                'indent',
                'quote',
              ],
              align: 'left',
              buttonsVisible: 3,
            },
            moreRich: {
              buttons: [
                'insertTable',
                'insertLink',
                'insertImage',
                'insertVideo',
                'emoticons',
                'fontAwesome',
                'specialCharacters',
                'embedly',
                'insertFile',
                'insertHR',
              ],
              align: 'left',
              buttonsVisible: 3,
            },
            moreMisc: {
              buttons: [
                'undo',
                'redo',
                'fullscreen',
                'print',
                'getPDF',
                'spellChecker',
                'selectAll',
                'html',
                'help',
              ],
              align: 'right',
              buttonsVisible: 2,
            },
          },
        }}
        model={props.value}
        onModelChange={handleBodyFroala}
      />
    </FroalaWrapper>
  )
}

export default FroalaBody
